import { render } from "./UISwitch.vue?vue&type=template&id=445b2d94"
import script from "./UISwitch.vue?vue&type=script&lang=js"
export * from "./UISwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__